import { Injectable } from '@angular/core';
import { ITipoPagoData } from '@core/interfaces/entidades/tipoPago.entidad';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TipoPagoService {
  protected tiposPago = new BehaviorSubject<ITipoPagoData[]>([]);

  get listTiposPago(): Observable<ITipoPagoData[]> {
    return this.tiposPago.asObservable();
  }
  setTiposPago(tiposPago: ITipoPagoData[]) {
    this.tiposPago.next(tiposPago);
  }
  addTipoPago(tipoPago: ITipoPagoData) {
    this.tiposPago.next([...this.tiposPago.value, tipoPago]);
  }
  quitarTipoPago(id: number) {
    this.tiposPago.next(this.tiposPago.value.filter((v) => v.id !== id));
  }
  editarTipoPago(tipoPago: ITipoPagoData) {
    this.tiposPago.next([...this.tiposPago.value.filter((c) => c.id !== tipoPago.id), tipoPago]);
  }
}
